import {GoingNewUtils} from "xmgoing-utils";

/**
 * 文件上传配置Hook
 * 封装文件上传相关的配置计算逻辑
 */
export function useFileUploadConfig({
  props,
  pModelObj,
  model,
  disabledState,
  readOnlyState,
  hiddenState
}: any) {

  /**
   * 生成临时业务ID
   */
  const busTempId = ref('');
  const getBusId = computed(() => {
    if (unref(readOnlyState) || unref(hiddenState)===false) {
      return;
    }
    // 只在 busTempId 为空时生成新 ID
    if (!unref(busTempId)) {
      const fileBusId = "xmFileUpload_" + GoingNewUtils.getUUChar(20);
      busTempId.value = fileBusId;
    }
    return unref(busTempId);
  });

  /**
   * 动态计算文件输入组件的属性
   * 根据 readFileUrl 决定传递不同的 props
   */
  const fileInputProps = computed(() => {
    // 确保 fileInputProps 依赖于 busTempId，以便 busTempId 变化时重新计算
    const currentBusId = unref(busTempId) || unref(getBusId);

    if (unref(props).readFileUrl) {
      // readFileUrl 为 true 时：使用 value 模式
      return {
        uploadAction: unref(props).uploadAction,
        value: unref(pModelObj)[unref(model).key],
        'onUpdate:value': (val: any) => {
          unref(pModelObj)[unref(model).key] = val;
        }
      };
    } else {
      // readFileUrl 为 false 时：使用 businessId 模式
      return {
        userUploadAction: unref(props).uploadAction,
        loadFileFlag: !!unref(pModelObj)[unref(model).key],
        businessId: unref(pModelObj)[unref(model).key] || currentBusId,
        'onUpdate:busId': (val: any) => {
          unref(pModelObj)[unref(model).key] = val;
        }
      };
    }
  });

  /**
   * 动态计算文件权限配置
   */
  const fileAclInfo = computed(() => {
    const download = unref(props).download !== false;
    const preview = unref(props).preview !== false;
    const upload = true;

    let deleteFlag: boolean;
    if (unref(props).readFileUrl) {
      deleteFlag = unref(props).delete !== false;
    } else {
      deleteFlag = !(unref(disabledState) || unref(readOnlyState));
    }

    return {
      download,
      preview,
      delete: deleteFlag,
      upload
    };
  });

  /**
   * 动态计算禁用状态
   */
  const fileInputDisabled = computed(() => {
    if (unref(props).readFileUrl) {
      return unref(disabledState);
    } else {
      return unref(disabledState) || unref(readOnlyState);
    }
  });

  /**
   * 监听模型值变化，清空文件列表
   */
  const setupModelValueWatch = (xmFileInputRef: Ref) => {
    watch(() => unref(pModelObj)[unref(model).key], (newVal) => {
      if (newVal == null || newVal === '') {
        xmFileInputRef.value?.clearFileList?.();
      }
    });
  };

  /**
   * 重新生成业务ID
   */
  const regenerateBusId = () => {
    const newBusId = "xmFileUpload_" + GoingNewUtils.getUUChar(20);
    busTempId.value = newBusId;
    return newBusId;
  };

  return {
    busTempId,
    getBusId,
    fileInputProps,
    fileAclInfo,
    fileInputDisabled,
    setupModelValueWatch,
    regenerateBusId
  };
}
